export default __webpack_public_path__ + "static/media/ed2d2fcc365f95da821850daf14cf433.svg";